// import React from 'react';
// import { FaPhone, FaEnvelope } from 'react-icons/fa';

// const ContactUs = () => {
//   return (
//     <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 lg:py-24 mt-24">


//       {/* Main container */}
//       <div className="bg-[#1e4d91] rounded-3xl shadow-lg overflow-hidden w-full relative">
//         <div className="flex flex-col lg:flex-row">
//           {/* Form Section */}
//           <div className='bg-white w-full lg:w-3/4 p-6 sm:p-8 md:p-12 lg:p-16 '>
//             <div className="h-full flex flex-col justify-center">
//               <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//                 Contact <span className="text-[#1e4d91]">us</span>
//               </h2>
//               <p className="text-sm sm:text-base text-gray-500 mb-6 max-w-sm">
//                 Enim tempor eget pharetra facilisis sed maecenas adipiscing. Eu leo molestie vel, ornare non id blandit netus.
//               </p>

//               <form className="space-y-4 w-full lg:max-w-md">
//                 <input
//                   type="text"
//                   placeholder="Name *"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <input
//                   type="tel"
//                   placeholder="Mobile number"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                 />
//                 <input
//                   type="email"
//                   placeholder="Email"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                 />
//                 <select 
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                 >
//                   <option>Loan type</option>
//                   <option>Personal Loan</option>
//                   <option>Home Loan</option>
//                   <option>Car Loan</option>
//                 </select>
//                 <textarea
//                   placeholder="Message *"
//                   rows="3"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 ></textarea>

//                 <button
//                   type="submit"
//                   className="w-full bg-[#1e4d91] text-white font-semibold py-2 sm:py-3 rounded-md hover:bg-blue-700 transition text-sm sm:text-base"
//                 >
//                   SEND
//                 </button>
//               </form>

//               {/* Contact Info - Hidden on mobile, shows on larger screens */}
//               <div className="hidden lg:block mt-6 text-sm text-gray-600 space-y-2">
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaPhone className='rotate-90 text-base' />
//                   <a href="tel:8973739377" className="hover:underline">
//                     8973739377
//                   </a>
//                 </div>
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaEnvelope className="text-base" />
//                   <a 
//                     href="mailto:subramaniamfinancialservices@gmail.com" 
//                     className="hover:underline break-all text-xs sm:text-sm"
//                   >
//                     subramaniamfinancialservices@gmail.com
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Map Section - Only shows on larger screens */}
//           <div className="hidden lg:block absolute right-[7%] top-1/2 -translate-y-1/2 h-[calc(100%-15rem)] w-[35%] xl:w-[40%] 2xl:w-[38%]">
//             <div className="h-full w-full rounded-3xl overflow-hidden shadow-xl border-l border-t border-b border-gray-200">
//               <iframe
//                 title="Google Map"
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1980.751328528752!2d-0.11954358415877628!3d51.5008436796337!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604ce07b8bfbf%3A0x9c8fbb64cf1d4db0!2sLondon%20Eye!5e0!3m2!1sen!2sin!4v1629384610462!5m2!1sen!2sin"
//                 width="100%"
//                 height="100%"
//                 allowFullScreen=""
//                 loading="lazy"
//                 className="absolute inset-0 w-full h-full rounded-3xl"
//               ></iframe>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Contact Info - Only shows on small screens */}
//       <div className="lg:hidden bg-white rounded-xl shadow-md p-6 space-y-4 mt-6">
//         <div className="text-sm text-gray-600 flex flex-col gap-4">
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaPhone className='rotate-90 text-base' />
//             <a href="tel:8973739377" className="hover:underline">
//               8973739377
//             </a>
//           </div>
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaEnvelope className="text-base" />
//             <a 
//               href="mailto:subramaniamfinancialservices@gmail.com" 
//               className="hover:underline break-all"
//             >
//               subramaniamfinancialservices@gmail.com
//             </a>
//           </div>
//         </div>

//         {/* Mobile Map */}
//         <div className="h-64 w-full rounded-lg bg-white shadow-sm overflow-hidden border border-gray-200">
//           <iframe
//             title="Google Map"
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1980.751328528752!2d-0.11954358415877628!3d51.5008436796337!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604ce07b8bfbf%3A0x9c8fbb64cf1d4db0!2sLondon%20Eye!5e0!3m2!1sen!2sin!4v1629384610462!5m2!1sen!2sin"
//             width="100%"
//             height="100%"
//             allowFullScreen=""
//             loading="lazy"
//             className="w-full h-full"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;

// import React, { useState, useRef } from 'react';
// import { FaPhone, FaEnvelope } from 'react-icons/fa';
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // cSpell: ignore Subramaniam Enim tempor pharetra facilisis maecenas adipiscing eget molestie ornare blandit netus Toastify
// const ContactUs = () => {
//   const formRef = useRef(null);
//   const iframeRef = useRef(null);
//   const [loading, setLoading] = useState(false);

//   const handleIframeLoad = () => {
//     if (loading) {
//       toast.success("Form submitted successfully!");
//       setLoading(false);
//       formRef.current.reset();
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     formRef.current.submit();
//   };


//   return (
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 lg:py-24 mt-24">
//       {/* Main container */}
//       <div className="bg-[#1e4d91] rounded-3xl shadow-lg overflow-hidden w-full relative">
//         <div className="flex flex-col lg:flex-row">
//           {/* Form Section */}
//           <div className='bg-white w-full lg:w-3/4 p-6 sm:p-8 md:p-12 lg:p-16'>
//             <div className="h-full flex flex-col justify-center">
//               <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//                 Contact <span className="text-[#1e4d91]">us</span>
//               </h2>
//               <p className="text-sm sm:text-base text-gray-500 mb-6 max-w-sm">
//                 Reach out to Subramaniam Financial Services for trusted guidance on loans, insurance and smart financial planning.
//               </p>

//               <form onSubmit={handleSubmit} className="space-y-4 w-full lg:max-w-md"
//                 ref={formRef}
//                 method="POST"
//                 target="hidden_iframe"
//                 // action="https://script.google.com/macros/s/AKfycbz5sLByFOneMIFOUFt7qd24vzxfX6kgxjJyx-TWSaaKzOiOSNvj4Avg2DxsmZpWBC_M/exec"
//                 action="https://script.google.com/macros/s/AKfycbyI7D_vEFQrKO6kkCdtKX0_ZexRpmQC5MGMKFRGnBnnF5YG52rliNM4Hisy9BNm_97v8w/exec"
                
//               >
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Name *"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <input
//                   type="tel"
//                   name="mobile"
//                   placeholder="Mobile number"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <select
//                   name="loanType"
//                   defaultValue=""
//                   className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base" required
//                 >
//                   <option value="" disabled>Loan type</option>
//                   <option value="Personal Loan">Personal Loan</option>
//                   <option value="Home Loan">Home Loan</option>
//                   <option value="Vehicle Loan">Vehicle Loan</option>
//                   <option value="Business Loan">Business Loan</option>
//                 </select>
//                 <textarea
//                   name="message"
//                   placeholder="Message *"
//                   rows="3"
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 ></textarea>

//                 <button
//                   type="submit"
//                   className="w-full bg-[#1e4d91] text-white font-semibold py-2 sm:py-3 rounded-md hover:bg-blue-700 transition text-sm sm:text-base disabled:opacity-50"
//                   disabled={loading}
//                 >
//                   {loading ? 'Submitting...' : 'Submit'}
//                 </button>
//               </form>

//               <iframe
//                 name="hidden_iframe"
//                 className="hidden"
//                 ref={iframeRef}
//                 onLoad={handleIframeLoad}
//                 title="submission_frame"
//               ></iframe>

//               <ToastContainer />

//               {/* Contact Info - Hidden on mobile, shows on larger screens */}
//               <div className="hidden lg:block mt-6 text-sm text-gray-600 space-y-2">
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaPhone className='rotate-90 text-base ' />
//                   <a href="tel:8973739377" className="hover:underline">
//                     8973739377
//                   </a>
//                 </div>
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaEnvelope className="text-base" />
//                   <a
//                     href="mailto:subramaniamfinancialservices@gmail.com"
//                     className="hover:underline break-all text-xs sm:text-sm"
//                   >
//                     subramaniamfinancialservices@gmail.com
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Map Section - Only shows on larger screens */}
//           <div className="hidden lg:block absolute right-[7%] top-1/2 -translate-y-1/2 h-[calc(100%-15rem)] w-[35%] xl:w-[40%] 2xl:w-[38%]">
//             <div className="h-full w-full rounded-3xl overflow-hidden shadow-xl border-l border-t border-b border-gray-200">
//               <iframe src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
//                 width="100%"
//                 height="100%"
//                 title="Google Map"
//                 allowFullScreen=""
//                 loading="lazy"
//                 className="absolute inset-0 w-full h-full rounded-3xl"
//               ></iframe>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Contact Info - Only shows on small screens */}
//       <div className="lg:hidden bg-white rounded-xl shadow-md p-6 space-y-4 mt-6">
//         <div className="text-sm text-gray-600 flex flex-col gap-4">
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaPhone className='rotate-90 text-base' />
//             <a href="tel:8973739377" className="hover:underline">
//               8973739377
//             </a>
//           </div>
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaEnvelope className="text-base" />
//             <a
//               href="mailto:subramaniamfinancialservices@gmail.com"
//               className="hover:underline break-all"
//             >
//               subramaniamfinancialservices@gmail.com
//             </a>
//           </div>
//         </div>

//         {/* Mobile Map */}
//         <div className="h-64 md:h-96 w-full rounded-lg bg-white shadow-sm overflow-hidden border border-gray-200">
//           <iframe src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
//             width="100%"
//             height="100%"
//             title="Google Map"
//             allowFullScreen=""
//             loading="lazy"
//             className="w-full h-full"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;

// import React, { useState, useRef } from 'react';
// import { FaPhone, FaEnvelope } from 'react-icons/fa';
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // cSpell: ignore Subramaniam Enim tempor pharetra facilisis maecenas adipiscing eget molestie ornare blandit netus Toastify
// const ContactUs = () => {
//   const formRef = useRef(null);
//   const iframeRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedLoanType, setSelectedLoanType] = useState('');
//   const [formData, setFormData] = useState({
//     name: '',
//     mobile: '',
//     email: '',
//     loanType: '',
//     message: '',
//     location: '',
//     employmentType: '',
//     monthlyIncome: '',
//     personalLoanAmount: '',
//     personalTenure: '',
//     personalPurpose: '',
//     existingLoans: '',
//     propertyValue: '',
//     homeLoanAmount: '',
//     homeTenure: '',
//     downPayment: '',
//     propertyLocation: '',
//     propertyType: '',
//     vehicleType: '',
//     vehicleCost: '',
//     vehicleLoanAmount: '',
//     vehicleTenure: '',
//     vehicleDownPayment: '',
//     businessType: '',
//     businessAge: '',
//     annualTurnover: '',
//     businessLoanAmount: '',
//     businessTenure: '',
//     businessPurpose: '',
//   });

//   const handleIframeLoad = () => {
//     if (loading) {
//       toast.success("Form submitted successfully!");
//       setLoading(false);
//       formRef.current.reset();
//       setFormData({
//         name: '',
//         mobile: '',
//         email: '',
//         loanType: '',
//         message: '',
//         location: '',
//         employmentType: '',
//         monthlyIncome: '',
//         personalLoanAmount: '',
//         personalTenure: '',
//         personalPurpose: '',
//         existingLoans: '',
//         propertyValue: '',
//         homeLoanAmount: '',
//         homeTenure: '',
//         downPayment: '',
//         propertyLocation: '',
//         propertyType: '',
//         vehicleType: '',
//         vehicleCost: '',
//         vehicleLoanAmount: '',
//         vehicleTenure: '',
//         vehicleDownPayment: '',
//         businessType: '',
//         businessAge: '',
//         annualTurnover: '',
//         businessLoanAmount: '',
//         businessTenure: '',
//         businessPurpose: '',
//       });
//       setSelectedLoanType('');
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleLoanTypeChange = (e) => {
//     const value = e.target.value;
//     setSelectedLoanType(value);
//     setFormData((prev) => ({
//       ...prev,
//       loanType: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setLoading(true);
//     formRef.current.submit();
//   };

//   return (
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 lg:py-24 mt-24">
//       {/* Main container */}
//       <div className="bg-[#1e4d91] rounded-3xl shadow-[0_0_25px_rgba(0,0,0,0.09)] overflow-hidden w-full relative lg:min-h-[720px]">
//         <div className="flex flex-col lg:flex-row">
//           {/* Form Section */}
//           <div className='bg-white w-full lg:w-3/4 p-6 sm:p-8 md:p-12 lg:p-16'>
//             <div className="h-full flex flex-col justify-center">
//               <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
//                 Contact <span className="text-[#1e4d91]">us</span>
//               </h2>
//               <p className="text-sm sm:text-base text-gray-500 mb-6 max-w-sm">
//                 Reach out to Subramaniam Financial Services for trusted guidance on loans, insurance and smart financial planning.
//               </p>

//               <form
//                 onSubmit={handleSubmit}
//                 className="space-y-4 w-full lg:max-w-md"
//                 ref={formRef}
//                 method="POST"
//                 target="hidden_iframe"
//                 // action="https://script.google.com/macros/s/AKfycbz5sLByFOneMIFOUFt7qd24vzxfX6kgxjJyx-TWSaaKzOiOSNvj4Avg2DxsmZpWBC_M/exec"
//                 //action="https://script.google.com/macros/s/AKfycbyI7D_vEFQrKO6kkCdtKX0_ZexRpmQC5MGMKFRGnBnnF5YG52rliNM4Hisy9BNm_97v8w/exec"
//                 action="https://script.google.com/macros/s/AKfycbwiA20mY6sWkcXqm7IJaHWZCrNj67lY_l9yqZhZymonBkLlR4XRVdF7KnXHmCOcpZAh5A/exec"
//               >
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Name *"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <input
//                   type="tel"
//                   name="mobile"
//                   placeholder="Mobile number"
//                   value={formData.mobile}
//                   onChange={handleInputChange}
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 />
//                 <select
//                   name="loanType"
//                   value={formData.loanType}
//                   onChange={handleLoanTypeChange}
//                   className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 >
//                   <option value="" >Loan type</option>
//                   <option value="Personal Loan">Personal Loan</option>
//                   <option value="Home Loan">Home Loan</option>
//                   <option value="Vehicle Loan">Vehicle Loan</option>
//                   <option value="Business Loan">Business Loan</option>
//                 </select>

//                 {selectedLoanType && (
//                   <>
//                     <div className="border-t border-gray-200 pt-4">
//                       <h3 className="text-base font-semibold text-gray-700 mb-3">
//                         {selectedLoanType} details
//                       </h3>

//                       <input
//                         type="text"
//                         name="location"
//                         placeholder="City/Location *"
//                         value={formData.location}
//                         onChange={handleInputChange}
//                         className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                         required
//                       />
//                       <select
//                         name="employmentType"
//                         value={formData.employmentType}
//                         onChange={handleInputChange}
//                         className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                         required
//                       >
//                         <option value="" disabled>Employment Type *</option>
//                         <option value="Salaried">Salaried</option>
//                         <option value="Self-Employed">Self-Employed</option>
//                         <option value="Business Owner">Business Owner</option>
//                       </select>
//                       <input
//                         type="number"
//                         name="monthlyIncome"
//                         placeholder="Monthly Income (₹) *"
//                         value={formData.monthlyIncome}
//                         onChange={handleInputChange}
//                         className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                         required
//                       />

//                       {selectedLoanType === 'Personal Loan' && (
//                         <>
//                           <input
//                             type="number"
//                             name="personalLoanAmount"
//                             placeholder="Loan Amount Required (₹) *"
//                             value={formData.personalLoanAmount}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="personalTenure"
//                             value={formData.personalTenure}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Tenure (Months) *</option>
//                             <option value="12">12 Months</option>
//                             <option value="24">24 Months</option>
//                             <option value="36">36 Months</option>
//                             <option value="48">48 Months</option>
//                             <option value="60">60 Months</option>
//                           </select>
//                           <select
//                             name="personalPurpose"
//                             value={formData.personalPurpose}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Purpose of Loan *</option>
//                             <option value="Home Renovation">Home Renovation</option>
//                             <option value="Wedding Expenses">Wedding Expenses</option>
//                             <option value="Education">Education</option>
//                             <option value="Medical">Medical</option>
//                             <option value="Vacation">Vacation</option>
//                             <option value="Debt Consolidation">Debt Consolidation</option>
//                             <option value="Other">Other</option>
//                           </select>
//                           <input
//                             type="number"
//                             name="existingLoans"
//                             placeholder="Existing Loans (₹)"
//                             value={formData.existingLoans}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                           />
//                         </>
//                       )}

//                       {selectedLoanType === 'Home Loan' && (
//                         <>
//                           <input
//                             type="number"
//                             name="propertyValue"
//                             placeholder="Property Value (₹) *"
//                             value={formData.propertyValue}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <input
//                             type="number"
//                             name="homeLoanAmount"
//                             placeholder="Loan Amount Required (₹) *"
//                             value={formData.homeLoanAmount}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="homeTenure"
//                             value={formData.homeTenure}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Tenure (Years) *</option>
//                             <option value="5">5 Years</option>
//                             <option value="10">10 Years</option>
//                             <option value="15">15 Years</option>
//                             <option value="20">20 Years</option>
//                           </select>
//                           <input
//                             type="number"
//                             name="downPayment"
//                             placeholder="Down Payment (₹) *"
//                             value={formData.downPayment}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <input
//                             type="text"
//                             name="propertyLocation"
//                             placeholder="Property Location *"
//                             value={formData.propertyLocation}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="propertyType"
//                             value={formData.propertyType}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Property Type *</option>
//                             <option value="New">New</option>
//                             <option value="Resale">Resale</option>
//                           </select>
//                         </>
//                       )}

//                       {selectedLoanType === 'Vehicle Loan' && (
//                         <>
//                           <select
//                             name="vehicleType"
//                             value={formData.vehicleType}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Vehicle Type *</option>
//                             <option value="Car">Car</option>
//                             <option value="Bike">Bike</option>
//                             <option value="Commercial Vehicle">Commercial Vehicle</option>
//                             <option value="Used Vehicle">Used Vehicle</option>
//                           </select>
//                           <input
//                             type="number"
//                             name="vehicleCost"
//                             placeholder="Vehicle Cost (₹) *"
//                             value={formData.vehicleCost}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <input
//                             type="number"
//                             name="vehicleLoanAmount"
//                             placeholder="Loan Amount Required (₹) *"
//                             value={formData.vehicleLoanAmount}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="vehicleTenure"
//                             value={formData.vehicleTenure}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Tenure (Months) *</option>
//                             <option value="24">24 Months</option>
//                             <option value="36">36 Months</option>
//                             <option value="48">48 Months</option>
//                             <option value="60">60 Months</option>
//                           </select>
//                           <input
//                             type="number"
//                             name="vehicleDownPayment"
//                             placeholder="Down Payment (₹) *"
//                             value={formData.vehicleDownPayment}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                         </>
//                       )}

//                       {selectedLoanType === 'Business Loan' && (
//                         <>
//                           <input
//                             type="text"
//                             name="businessType"
//                             placeholder="Business Type *"
//                             value={formData.businessType}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="businessAge"
//                             value={formData.businessAge}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Business Age *</option>
//                             <option value="Less than 1 year">Less than 1 year</option>
//                             <option value="1-3 years">1-3 years</option>
//                             <option value="3-5 years">3-5 years</option>
//                             <option value="More than 5 years">More than 5 years</option>
//                           </select>
//                           <input
//                             type="number"
//                             name="annualTurnover"
//                             placeholder="Annual Turnover (₹) *"
//                             value={formData.annualTurnover}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <input
//                             type="number"
//                             name="businessLoanAmount"
//                             placeholder="Loan Amount Required (₹) *"
//                             value={formData.businessLoanAmount}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                           <select
//                             name="businessTenure"
//                             value={formData.businessTenure}
//                             onChange={handleInputChange}
//                             className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           >
//                             <option value="" disabled>Tenure (Months) *</option>
//                             <option value="12">12 Months</option>
//                             <option value="24">24 Months</option>
//                             <option value="36">36 Months</option>
//                             <option value="48">48 Months</option>
//                             <option value="60">60 Months</option>
//                           </select>
//                           <input
//                             type="text"
//                             name="businessPurpose"
//                             placeholder="Purpose of Loan *"
//                             value={formData.businessPurpose}
//                             onChange={handleInputChange}
//                             className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
//                             required
//                           />
//                         </>
//                       )}
//                     </div>
//                   </>
//                 )}

//                 <textarea
//                   name="message"
//                   placeholder="Message *"
//                   rows="3"
//                   value={formData.message}
//                   onChange={handleInputChange}
//                   className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
//                   required
//                 ></textarea>

//                 <button
//                   type="submit"
//                   className="w-full bg-[#1e4d91] text-white font-semibold py-2 sm:py-3 rounded-md hover:bg-blue-700 transition text-sm sm:text-base disabled:opacity-50"
//                   disabled={loading}
//                 >
//                   {loading ? 'Submitting...' : 'Submit'}
//                 </button>
//               </form>

//               <iframe
//                 name="hidden_iframe"
//                 className="hidden"
//                 ref={iframeRef}
//                 onLoad={handleIframeLoad}
//                 title="submission_frame"
//               ></iframe>

//               <ToastContainer />

//               {/* Contact Info - Hidden on mobile, shows on larger screens */}
//               <div className="hidden lg:block mt-6 text-sm text-gray-600 space-y-2">
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaPhone className='rotate-90 text-base ' />
//                   <a href="tel:8973739377" className="hover:underline">
//                     8973739377
//                   </a>
//                 </div>
//                 <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//                   <FaEnvelope className="text-base" />
//                   <a
//                     href="mailto:subramaniamfinancialservices@gmail.com"
//                     className="hover:underline break-all text-xs sm:text-sm"
//                   >
//                     subramaniamfinancialservices@gmail.com
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Map Section - Only shows on larger screens */}
//           {/* <div className="hidden lg:block absolute right-[7%] top-1/2 -translate-y-1/2 h-[calc(100%-15rem)] w-[35%] xl:w-[40%] 2xl:w-[38%]">
//             <div className="h-full w-full rounded-3xl overflow-hidden shadow-xl border-l border-t border-b border-gray-200">
//               <iframe
//                 src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
//                 width="100%"
//                 height="100%"
//                 title="Google Map"
//                 allowFullScreen=""
//                 loading="lazy"
//                 className="absolute inset-0 w-full h-full rounded-3xl"
//               ></iframe>
//             </div>
//           </div> */}
//           {/* Map Section */}
//           <div className="hidden lg:block absolute right-[6%] top-24 w-[38%] z-10">

//             <div className="h-[540px] w-full rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.18)] border border-gray-200 bg-white">

//               <iframe
//                 src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
//                 width="100%"
//                 height="100%"
//                 title="Google Map"
//                 allowFullScreen=""
//                 loading="lazy"
//                 className="w-full h-full"
//               ></iframe>

//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Mobile Contact Info - Only shows on small screens */}
//       <div className="lg:hidden bg-white rounded-xl shadow-md p-6 space-y-4 mt-6">
//         <div className="text-sm text-gray-600 flex flex-col gap-4">
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaPhone className='rotate-90 text-base' />
//             <a href="tel:8973739377" className="hover:underline">
//               8973739377
//             </a>
//           </div>
//           <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
//             <FaEnvelope className="text-base" />
//             <a
//               href="mailto:subramaniamfinancialservices@gmail.com"
//               className="hover:underline break-all"
//             >
//               subramaniamfinancialservices@gmail.com
//             </a>
//           </div>
//         </div>

//         {/* Mobile Map */}
//         <div className="h-64 md:h-96 w-full rounded-lg bg-white shadow-sm overflow-hidden border border-gray-200">
//           <iframe
//             src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
//             width="100%"
//             height="100%"
//             title="Google Map"
//             allowFullScreen=""
//             loading="lazy"
//             className="w-full h-full"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;

import React, { useState, useRef } from 'react';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
  const formRef = useRef(null);
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedLoanType, setSelectedLoanType] = useState('');

  const initialFormData = {
    name: '',
    mobile: '',
    email: '',
    loanType: '',
    message: '',
    location: '',
    employmentType: '',
    salaryMode: 'Account Credited',
    bankAccountType: '',
    monthlyIncomeRange: '',
    monthlyIncome: '',
    selfEmployedDocType: '',
    salaryProof: '',
    loanAmountRange: '',
    personalLoanAmount: '',
    personalTenure: '',
    personalPurpose: '',
    existingLoans: '',
    propertyValue: '',
    homeLoanAmount: '',
    homeTenure: '',
    downPayment: '',
    propertyLocation: '',
    propertyType: '',
    homeLoanProductType: '',
    homeLoanAction: '',
    buildingType: '',
    vehicleType: '',
    equipmentLoanType: '',
    equipmentOtherType: '',
    equipmentCost: '',
    equipmentLoanAmount: '',
    equipmentTenure: '',
    equipmentDownPayment: '',
    businessType: '',
    businessAge: '',
    businessDocType: '',
    annualTurnover: '',
    businessLoanAmount: '',
    businessTenure: '',
    businessPurpose: '',
    lapBuildingType: '',
    lapEmploymentType: '',
    lapSelfEmployedType: '',
    lapAction: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleIframeLoad = () => {
    if (loading) {
      toast.success('Form submitted successfully!');
      setLoading(false);
      formRef.current.reset();
      setSelectedLoanType('');
      setFormData(initialFormData);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoanTypeChange = (e) => {
    const value = e.target.value;
    setSelectedLoanType(value);
    setFormData((prev) => ({
      ...prev,
      loanType: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation for Personal Loan - net salary must be 15k above
    if (selectedLoanType === 'Personal Loan') {
      const salary = parseFloat(formData.monthlyIncome);
      if (salary < 15000) {
        toast.error('Net salary must be ₹15,000 or above for Personal Loan');
        return;
      }
    }

    setLoading(true);
    formRef.current.submit();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 lg:py-24 mt-24">
      <div className="bg-[#1e4d91] rounded-3xl shadow-[0_0_25px_rgba(0,0,0,0.09)] overflow-hidden w-full relative lg:min-h-[720px]">
        <div className="flex flex-col lg:flex-row">
          <div className="bg-white w-full lg:w-3/4 p-6 sm:p-8 md:p-12 lg:p-16">
            <div className="h-full flex flex-col justify-center">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
                Contact <span className="text-[#1e4d91]">us</span>
              </h2>
              <p className="text-sm sm:text-base text-gray-500 mb-6 max-w-sm">
                Reach out to Subramaniam Financial Services for trusted guidance on loans, insurance and smart financial planning.
              </p>

              <form
                ref={formRef}
                onSubmit={handleSubmit}
                className="space-y-4 w-full lg:max-w-md"
                method="POST"
                target="hidden_iframe"
                action="https://script.google.com/macros/s/AKfycbwiA20mY6sWkcXqm7IJaHWZCrNj67lY_l9yqZhZymonBkLlR4XRVdF7KnXHmCOcpZAh5A/exec"
              >
                <input
                  type="text"
                  name="name"
                  placeholder="Name *"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                  required
                />
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile number *"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                  required
                />
                <select
                  name="loanType"
                  value={formData.loanType}
                  onChange={handleLoanTypeChange}
                  className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                  required
                >
                  <option value="">Loan type</option>
                  <option value="Personal Loan">Personal Loan</option>
                  <option value="Home Loan">Home Loan</option>
                  <option value="Vehicle Loan">Vehicle Loan</option>
                  <option value="Construction Equipment Loan">Construction Equipment Loan</option>
                  <option value="Business Loan">Business Loan</option>
                  <option value="Loan Against Property">Loan Against Property</option>
                </select>

                {selectedLoanType && (
                  <div className="border-t border-gray-200 pt-4">
                    <h3 className="text-base font-semibold text-gray-700 mb-3">
                      {selectedLoanType} details
                    </h3>

                    <input
                      type="text"
                      name="location"
                      placeholder="City / Location *"
                      value={formData.location}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                      required
                    />

                    <select
                      name="employmentType"
                      value={formData.employmentType}
                      onChange={handleInputChange}
                      className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                      required
                    >
                      <option value="" disabled>
                        Employment Type *
                      </option>
                      <option value="Salaried">Salaried</option>
                      <option value="Self-Employed">Self-Employed</option>
                      <option value="Business Owner">Business Owner</option>
                    </select>

                    {selectedLoanType !== 'Construction Equipment Loan' && (
                      <>
                        <select
                          name="salaryMode"
                          value={formData.salaryMode}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Salary Type *
                          </option>
                          {selectedLoanType === 'Personal Loan' ? (
                            <option value="Account Credited">Account Credited</option>
                          ) : (
                            <>
                              <option value="Account Credited">Account Credited</option>
                              <option value="Cash Salary">Cash Salary</option>
                            </>
                          )}
                        </select>

                        <select
                          name="bankAccountType"
                          value={formData.bankAccountType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Bank Account Type *
                          </option>
                          <option value="Savings">Savings</option>
                          <option value="Current">Current</option>
                        </select>

                        <select
                          name="monthlyIncomeRange"
                          value={formData.monthlyIncomeRange}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Monthly Income Range *
                          </option>
                          <option value="1-3 Lakh">1-3 Lakh</option>
                          <option value="3-5 Lakh">3-5 Lakh</option>
                          <option value="5 Lakh and Above">5 Lakh and Above</option>
                        </select>

                        <input
                          type="number"
                          name="monthlyIncome"
                          placeholder="Exact Monthly Income (₹) *"
                          value={formData.monthlyIncome}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                      </>
                    )}

                    {formData.employmentType === 'Self-Employed' && selectedLoanType !== 'Construction Equipment Loan' && (
                      <select
                        name="selfEmployedDocType"
                        value={formData.selfEmployedDocType}
                        onChange={handleInputChange}
                        className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                        required
                      >
                        <option value="" disabled>
                          Self Employed Documents *
                        </option>
                        <option value="ITR">ITR</option>
                        <option value="GST">GST</option>
                        <option value="ITR + GST">ITR + GST</option>
                      </select>
                    )}

                    {selectedLoanType === 'Personal Loan' && (
                      <>
                        <div className="border-t border-gray-200 pt-4 mt-4">
                          <p className="text-sm text-gray-600 mb-3">
                            <strong>Requirements:</strong> Payslip available, Net salary ₹15,000 or above, Account credited
                          </p>
                        </div>

                        <input
                          type="number"
                          name="personalLoanAmount"
                          placeholder="Loan Amount Required (₹) *"
                          value={formData.personalLoanAmount}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="personalTenure"
                          value={formData.personalTenure}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Tenure (Months) *
                          </option>
                          <option value="12">12 Months</option>
                          <option value="24">24 Months</option>
                          <option value="36">36 Months</option>
                          <option value="48">48 Months</option>
                          <option value="60">60 Months</option>
                          <option value="72">72 Months</option>
                        </select>
                        <select
                          name="personalPurpose"
                          value={formData.personalPurpose}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Purpose of Loan *
                          </option>
                          <option value="Home Renovation">Home Renovation</option>
                          <option value="Wedding Expenses">Wedding Expenses</option>
                          <option value="Education">Education</option>
                          <option value="Medical">Medical</option>
                          <option value="Vacation">Vacation</option>
                          <option value="Debt Consolidation">Debt Consolidation</option>
                          <option value="Other">Other</option>
                        </select>
                        <input
                          type="number"
                          name="existingLoans"
                          placeholder="Existing Loans (₹)"
                          value={formData.existingLoans}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                        />
                      </>
                    )}

                    {selectedLoanType === 'Home Loan' && (
                      <>
                        <select
                          name="homeLoanProductType"
                          value={formData.homeLoanProductType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Home Loan Product *
                          </option>
                          <option value="Self Construction">Self Construction</option>
                          <option value="Plot Purchase with Construction">
                            Plot Purchase with Construction
                          </option>
                          <option value="New/Old House Purchase">New/Old House Purchase</option>
                          <option value="Home Renovation">Home Renovation</option>
                          <option value="Vacant Land Purchase">Vacant Land Purchase</option>
                          <option value="Commercial Building Purchase">
                            Commercial Building Purchase
                          </option>
                          <option value="Commercial Building Construction">
                            Commercial Building Construction
                          </option>
                        </select>

                        <select
                          name="homeLoanAction"
                          value={formData.homeLoanAction}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Home Loan Type *
                          </option>
                          <option value="Home Loan Purchase">Home Loan Purchase</option>
                          <option value="Takeover">Takeover</option>
                          <option value="Topup">Topup</option>
                        </select>

                        <input
                          type="number"
                          name="propertyValue"
                          placeholder="Property Value (₹) *"
                          value={formData.propertyValue}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <input
                          type="number"
                          name="homeLoanAmount"
                          placeholder="Loan Amount Required (₹) *"
                          value={formData.homeLoanAmount}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="homeTenure"
                          value={formData.homeTenure}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Tenure (Years) *
                          </option>
                          <option value="5">5 Years</option>
                          <option value="10">10 Years</option>
                          <option value="15">15 Years</option>
                          <option value="20">20 Years</option>
                          <option value="25">25 Years</option>
                        </select>
                        <input
                          type="number"
                          name="downPayment"
                          placeholder="Down Payment (₹) *"
                          value={formData.downPayment}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <input
                          type="text"
                          name="propertyLocation"
                          placeholder="Property Location *"
                          value={formData.propertyLocation}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="propertyType"
                          value={formData.propertyType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Property Type *
                          </option>
                          <option value="New">New</option>
                          <option value="Resale">Resale</option>
                        </select>
                        <select
                          name="buildingType"
                          value={formData.buildingType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Building Type *
                          </option>
                          <option value="Residential">Residential</option>
                          <option value="Commercial">Commercial</option>
                        </select>
                      </>
                    )}

                    {selectedLoanType === 'Vehicle Loan' && (
                      <>
                        <select
                          name="vehicleType"
                          value={formData.vehicleType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Vehicle Type *
                          </option>
                          <option value="Car">Car</option>
                          <option value="Bike">Bike</option>
                          <option value="Commercial Vehicle">Commercial Vehicle</option>
                          <option value="Used Vehicle">Used Vehicle</option>
                          <option value="Tractor Loan">Tractor Loan</option>
                        </select>
                        <input
                          type="number"
                          name="equipmentCost"
                          placeholder="Vehicle Cost (₹) *"
                          value={formData.equipmentCost}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <input
                          type="number"
                          name="equipmentLoanAmount"
                          placeholder="Loan Amount Required (₹) *"
                          value={formData.equipmentLoanAmount}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="equipmentTenure"
                          value={formData.equipmentTenure}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Tenure (Months) *
                          </option>
                          <option value="24">24 Months</option>
                          <option value="36">36 Months</option>
                          <option value="48">48 Months</option>
                          <option value="60">60 Months</option>
                        </select>
                        <input
                          type="number"
                          name="equipmentDownPayment"
                          placeholder="Down Payment (₹) *"
                          value={formData.equipmentDownPayment}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                      </>
                    )}

                    {selectedLoanType === 'Construction Equipment Loan' && (
                      <>
                        <select
                          name="businessType"
                          value={formData.businessType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Business Type *
                          </option>
                          <option value="Contract">Contract</option>
                          <option value="Earth Movers">Earth Movers</option>
                          <option value="Individual">Individual</option>
                        </select>
                        <input
                          type="number"
                          name="monthlyIncome"
                          placeholder="Monthly Income (₹) *"
                          value={formData.monthlyIncome}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="monthlyIncomeRange"
                          value={formData.monthlyIncomeRange}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Monthly Income Range *
                          </option>
                          <option value="1-3 Lakh">1-3 Lakh</option>
                          <option value="3-5 Lakh">3-5 Lakh</option>
                          <option value="5 Lakh and Above">5 Lakh and Above</option>
                        </select>

                        <div className="border-t border-gray-200 pt-4 mt-4">
                          <label className="text-base font-semibold text-gray-700 mb-3 block">
                            Equipment Type *
                          </label>
                          <select
                            name="equipmentLoanType"
                            value={formData.equipmentLoanType}
                            onChange={handleInputChange}
                            className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                            required
                          >
                            <option value="" disabled>
                              Select Equipment *
                            </option>
                            <option value="CB Backhoe Loader / JCB">
                              CB Backhoe Loader / JCB
                            </option>
                            <option value="Excavator / Poclain">Excavator / Poclain</option>
                            <option value="Mini Excavator">Mini Excavator</option>
                            <option value="Other">Other (Please specify)</option>
                          </select>
                        </div>

                        {formData.equipmentLoanType === 'Other' && (
                          <input
                            type="text"
                            name="equipmentOtherType"
                            placeholder="Please specify equipment type *"
                            value={formData.equipmentOtherType}
                            onChange={handleInputChange}
                            className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                            required
                          />
                        )}

                        <select
                          name="loanAmountRange"
                          value={formData.loanAmountRange}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Loan Amount Range *
                          </option>
                          <option value="5-10 Lakh">5-10 Lakh</option>
                          <option value="10-25 Lakh">10-25 Lakh</option>
                          <option value="25-50 Lakh">25-50 Lakh</option>
                          <option value="50 Lakh and Above">50 Lakh and Above</option>
                        </select>
                        <input
                          type="number"
                          name="equipmentCost"
                          placeholder="Equipment Cost (₹) *"
                          value={formData.equipmentCost}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <input
                          type="number"
                          name="equipmentLoanAmount"
                          placeholder="Loan Amount Required (₹) *"
                          value={formData.equipmentLoanAmount}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="equipmentTenure"
                          value={formData.equipmentTenure}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Tenure (Months) *
                          </option>
                          <option value="24">24 Months</option>
                          <option value="36">36 Months</option>
                          <option value="48">48 Months</option>
                          <option value="60">60 Months</option>
                        </select>
                        <input
                          type="number"
                          name="equipmentDownPayment"
                          placeholder="Down Payment (₹) *"
                          value={formData.equipmentDownPayment}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                      </>
                    )}

                    {selectedLoanType === 'Business Loan' && (
                      <>
                        <select
                          name="businessType"
                          value={formData.businessType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Business Type *
                          </option>
                          <option value="Contract">Contract</option>
                          <option value="Earth Movers">Earth Movers</option>
                          <option value="Individual">Individual</option>
                          <option value="Other">Other</option>
                        </select>
                        <select
                          name="businessAge"
                          value={formData.businessAge}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Business Age *
                          </option>
                          <option value="Less than 1 year">Less than 1 year</option>
                          <option value="1-3 years">1-3 years</option>
                          <option value="3-5 years">3-5 years</option>
                          <option value="More than 5 years">More than 5 years</option>
                        </select>
                        <select
                          name="businessDocType"
                          value={formData.businessDocType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Business Documents *
                          </option>
                          <option value="ITR">ITR</option>
                          <option value="GST">GST</option>
                          <option value="ITR + GST">ITR + GST</option>
                        </select>
                        <input
                          type="number"
                          name="annualTurnover"
                          placeholder="Annual Turnover (₹) *"
                          value={formData.annualTurnover}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="loanAmountRange"
                          value={formData.loanAmountRange}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Loan Amount Range *
                          </option>
                          <option value="5-10 Lakh">5-10 Lakh</option>
                          <option value="10-25 Lakh">10-25 Lakh</option>
                          <option value="25-50 Lakh">25-50 Lakh</option>
                          <option value="50 Lakh and Above">50 Lakh and Above</option>
                        </select>
                        <input
                          type="number"
                          name="businessLoanAmount"
                          placeholder="Loan Amount Required (₹) *"
                          value={formData.businessLoanAmount}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="businessTenure"
                          value={formData.businessTenure}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Tenure (Months) *
                          </option>
                          <option value="12">12 Months</option>
                          <option value="24">24 Months</option>
                          <option value="36">36 Months</option>
                          <option value="48">48 Months</option>
                          <option value="60">60 Months</option>
                        </select>
                        <input
                          type="text"
                          name="businessPurpose"
                          placeholder="Purpose of Loan *"
                          value={formData.businessPurpose}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                      </>
                    )}

                    {selectedLoanType === 'Loan Against Property' && (
                      <>
                        <select
                          name="lapEmploymentType"
                          value={formData.lapEmploymentType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Salary Type *
                          </option>
                          <option value="Account Salary">Account Salary</option>
                          <option value="Cash Salary">Cash Salary</option>
                        </select>
                        <select
                          name="lapSelfEmployedType"
                          value={formData.lapSelfEmployedType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Self Employment Type *
                          </option>
                          <option value="Self IT">Self IT</option>
                          <option value="Self Non IT">Self Non IT</option>
                        </select>
                        <select
                          name="lapBuildingType"
                          value={formData.lapBuildingType}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Building Type *
                          </option>
                          <option value="Residential">Residential</option>
                          <option value="Commercial">Commercial</option>
                        </select>
                        <select
                          name="lapAction"
                          value={formData.lapAction}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            LAP Purpose *
                          </option>
                          <option value="Takeover">Takeover</option>
                          <option value="Topup">Topup</option>
                          <option value="Loan Against Property">Loan Against Property</option>
                        </select>
                        <input
                          type="number"
                          name="propertyValue"
                          placeholder="Property Value (₹) *"
                          value={formData.propertyValue}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        />
                        <select
                          name="loanAmountRange"
                          value={formData.loanAmountRange}
                          onChange={handleInputChange}
                          className="w-full border bg-white border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base mt-3"
                          required
                        >
                          <option value="" disabled>
                            Loan Amount Range *
                          </option>
                          <option value="5-10 Lakh">5-10 Lakh</option>
                          <option value="10-25 Lakh">10-25 Lakh</option>
                          <option value="25-50 Lakh">25-50 Lakh</option>
                          <option value="50 Lakh and Above">50 Lakh and Above</option>
                        </select>
                      </>
                    )}
                  </div>
                )}

                <textarea
                  name="message"
                  placeholder="Message *"
                  rows="3"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-md p-2 sm:p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                  required
                ></textarea>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#1e4d91] text-white font-semibold py-2 sm:py-3 rounded-md hover:bg-blue-700 transition text-sm sm:text-base disabled:opacity-50"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </form>

              <iframe
                name="hidden_iframe"
                ref={iframeRef}
                className="hidden"
                onLoad={handleIframeLoad}
                title="submission_frame"
              ></iframe>

              <ToastContainer />

              <div className="hidden lg:block mt-6 text-sm text-gray-600 space-y-2">
                <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
                  <FaPhone className="rotate-90 text-base" />
                  <a href="tel:8973739377" className="hover:underline">
                    8973739377
                  </a>
                </div>
                <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
                  <FaEnvelope className="text-base" />
                  <a
                    href="mailto:subramaniamfinancialservices@gmail.com"
                    className="hover:underline break-all text-xs sm:text-sm"
                  >
                    subramaniamfinancialservices@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block absolute right-[6%] top-24 w-[38%] z-10">
            <div className="h-[540px] w-full rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.18)] border border-gray-200 bg-white">
              <iframe
                src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
                width="100%"
                height="100%"
                title="Google Map"
                allowFullScreen=""
                loading="lazy"
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:hidden bg-white rounded-xl shadow-md p-6 space-y-4 mt-6">
        <div className="text-sm text-gray-600 flex flex-col gap-4">
          <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
            <FaPhone className="rotate-90 text-base" />
            <a href="tel:8973739377" className="hover:underline">
              8973739377
            </a>
          </div>
          <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
            <FaEnvelope className="text-base" />
            <a
              href="mailto:subramaniamfinancialservices@gmail.com"
              className="hover:underline break-all"
            >
              subramaniamfinancialservices@gmail.com
            </a>
          </div>
        </div>

        <div className="h-64 md:h-96 w-full rounded-lg bg-white shadow-sm overflow-hidden border border-gray-200">
          <iframe
            src="https://www.google.com/maps/d/embed?mid=1GBESLDEGuCjmaJRmOU9uWQTTo5MMJiA&ehbc=2E312F"
            width="100%"
            height="100%"
            title="Google Map"
            allowFullScreen=""
            loading="lazy"
            className="w-full h-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;